import { toggleChatVisibility } from "#scripts/dialog/dialog_general.js";
import { bindDialogEvents } from "#scripts/dialog/dialog_events.js";
import { initBotInstance } from "#scripts/dialog/dialog_messages.js";
import { contentMeta, isMobile } from "#scripts/general_functions";
import { getImageByContentId } from "#scripts/images";
import language from "#scripts/translation";
import { getLangForApi } from "#scripts/cmsapi.js";
import * as Sentry from "@sentry/browser";

export const getFrontpageImages_old = async () => {
  const frontImageContentTypeId = "17c15981-758d-4d09-a7ee-b2d47d2af6f0";
  const apiCall = `${window.apiUrl}/Public/articles?subscriptionId=${window.serverdata.configMeta.aim.clientId}&contentType=${frontImageContentTypeId}
      &limit=${load}&offset=${from}&sortOrder=Published&language=${getLangForApi()}`;
  try {
    const response = await fetch(apiCall);
    if (!response.ok) {
      Sentry.captureMessage(`HTTP error! status: ${response.status}`);
    }
    const imagesList = await response.json();
    return imagesList;
  } catch (error) {
    Sentry.captureException(error);
  }
};

export const fetchFrontpageImages = async () => {
  const frontImageContentTypeId = "17c15981-758d-4d09-a7ee-b2d47d2af6f0";
  const apiCall = `${window.apiUrl}/Public/articles?subscriptionId=${window.serverdata.configMeta.aim.clientId}&contentType=${frontImageContentTypeId}
      &limit=1&offset=0&sortOrder=Published&language=${getLangForApi()}`;

  try {
    const response = await fetch(apiCall);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    Sentry.captureException(error);
    console.error("Error fetching front-page images:", error);
    return null;
  }
};

export default function () {
  /* Start template */
  const kariStartTemplate = () => {
    const config = JSON.parse(sessionStorage.getItem("config"));

    const kari = "";
    let extraKariLink = "";

    if (config.kariinfoLinkId) {
      extraKariLink = `
        <a href="/artikkel/${config.kariinfoLinkId}" class="dialog__actions__ddlink" aria-label="${language("DIALOG_EXTRALINK")} (${language("NAV_OPEN_I_NEW")})" target=_blank>${language(
        "DIALOG_EXTRALINK",
      )} <!--span class="material-icons-outlined notranslate">open_in_new</span--></a>`;
    }

    const kariHtml = `
      <div class="chatbot__mobile__header">
        <div class="row">
          <div class="col-6">
            <span class="chatbot__modal__header">
              Kommune-Kari
            </span>
          </div>
          <div class="col-6 text-right chatbot__modal__icons">
            <button class="chatbot__modal__button chatbot__modal__option" id="chatbot__modal__option" aria-label="hjelp"><span class="material-icons-outlined notranslate">help_outline</span></button>
            <button class="chatbot__modal__button chatbot__modal__close" id="chatbot__modal__close" aria-label="lukk"><span class="material-close-ui"></span></button>
          </div>
        </div>
      </div>
      <div class="chatbot__infopage">
        <div class="container dialog__infopage__container">
          <div class="row">
            <div class="col-12 text-center">
              <a href="#" class="dialog__actions__ddlink restart-chat">${language("DIALOG_RESTART")}</a>
              <a href="#" class="dialog__actions__ddlink download">${language("DIALOG_DOWNLOAD_CONVERSATION")}</a>
              <a href="#" class="dialog__actions__ddlink deletedialog">${language("DIALOG_DELETE_CONVERSATION")}</a>
              <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/" target=_blank class="dialog__actions__ddlink seePrivacy">${language(
      "DIALOG_PRIVACY",
    )} <span class="material-icons-outlined notranslate">open_in_new</span></a>
              ${extraKariLink}
              <button class="chatbot__infopage__close" id="chatbot__infopage__close">Tilbake</button>
            </div>
          </div>
        </div>
      </div>
      <div class="chatbot-search chatbot-search--container" data-background="">
        <div class="dialog__overlay__graph-right"><img src="" alt=""/></div>
        <div class="container dialog__messagearea__container" id="chatbot__messagearea">
          <div class="row h-100">
            <div class="col-lg-8 h-100">
              <div class="dialog dialog__messagearea h-100">
                <div class="dialog__scroller" id="dialog__scroller">
                  <div class="justify-content-lg-center jcm-tostart">
                    <div class="xcol-lg-10">
                      <div id="kari__dialog__window" class="dialog__container"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container dialog__inputarea__container">
          <div class="row">
            <div class="col-lg-8">
              <div class="dialog dialog__inputarea">
                <div class="xrow justify-content-lg-center jcm-toend">
                  <div class="xcol-lg-10">
                    <div class="dialog__avatarcontainer dialog__avatarcontainer-input">${kari}</div>
                    <div class="dialog__inputcontainer">
                      <input type="text" 
                        class="form-control dialog__input" 
                        id="feedbackInput" 
                        maxlength="110"
                        autocomplete="off" 
                        aria-label="${language("DIALOG_FEEDBACK")}" 
                        aria-describedby="chatinput__beskrivelse" 
                        placeholder="${language("START_OR_SEARCH")}">
                      <label for="feedbackInput" 
                        class="d-none">${language("DIALOG_FEEDBACK")}</label>
                      <small id="chatinput__beskrivelse" 
                        class="d-none text-muted">${language("DIALOG_MUTEINPUT")}</small>
                      <button type="button" class="dialog__sendbutton" aria-label="${language("DIALOG_SENDBTN")}">
                        <span class="material-icons-outlined notranslate dialog__sendbutton__icon"></span>
                      </button>
                      <div id="chatinput__charCounter" class="dialog__input-counter"></div>
                    </div>
                    <div class="dialog__askarea">
                      <button type="button" class="dialog__askbutton" aria-label="${language("DIALOG_ASKME")}" role="button">Spør meg
                        <span class="material-icons-outlined notranslate button__icon">arrow_forward</span>
                      </button>
                    </div>
                    <div class="dialog__actions__container">
                      <a href="#" class="dialog__actions__link restart-chat dialog__actions__link-hidden">
                        ${language("DIALOG_RESTART")}
                        <span class="material-icons-outlined notranslate">refresh</span>
                      </a>
                      <a href="#" class="dialog__actions__link dialog__actions__toggle">
                        ${language("DIALOG_INFORMATION")}<span class="dialog__chevron__toggle material-icons-outlined material-chevron-bottom notranslate"></span>
                      </a>
                      <div class="dialog__actions">
                        <a href="#" class="dialog__actions__ddlink download">${language("DIALOG_DOWNLOAD_CONVERSATION")}</a>
                        <a href="#" class="dialog__actions__ddlink deletedialog">${language("DIALOG_DELETE_CONVERSATION")}</a>
                        <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/" target=_blank class="dialog__actions__ddlink seePrivacy">
                          ${language("DIALOG_PRIVACY")} 
                          <span class="material-icons-outlined notranslate">open_in_new</span>
                        </a>
                        ${extraKariLink}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    // Append HTML to #chatbot__container
    const chatbotContainer = document.getElementById("chatbot__container");
    if (chatbotContainer) {
      chatbotContainer.insertAdjacentHTML("beforeend", kariHtml);
      if (isMobile()) {
        chatbotContainer.classList.add("chatbot__mobile");
      }
    }

    let frontImageId = "";
    fetchFrontpageImages().then((imageList) => {
      if (!imageList) return;
      for (const item of imageList.listOfContent) {
        if (item.contentTypeGuid === "17c15981-758d-4d09-a7ee-b2d47d2af6f0") {
          const meta = contentMeta(item);
          frontImageId = meta.imageContentId;
          getImageByContentId(frontImageId, (img) => {
            const viewMode = isMobile() ? "_mobile" : "";
            const elmDialog = document.querySelector(".chatbot-search--container");
            const maskImage = window.serverdata.configMeta.aim?.frontImageMask ? `url(${window.serverdata.configMeta.aim?.frontImageMask}), ` : "";
            const maskPosition = window.serverdata.configMeta.aim?.frontImageMask
              ? `calc(var(--dialog__cb__image_horizontal-position${viewMode}, center) - 1px) var(--dialog__cb__image_vertical-position${viewMode}, center), `
              : "";

            if (!isMobile() && elmDialog) {
              let url = img.url || window.serverdata.configMeta.aim.frontImage;
              if (url.includes("preview.sdl.no")) {
                url = url.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`);
              }

              const bgImage = `https://res.cloudinary.com/ssp/image/fetch/g_auto,c_fill,f_auto/${url}`;
              elmDialog.dataset.background = bgImage;
              elmDialog.style.backgroundImage = `${maskImage}url('${bgImage}')`;
              elmDialog.style.backgroundPosition = `${maskPosition}var(--dialog__cb__image_horizontal-position${viewMode}, center) var(--dialog__cb__image_vertical-position${viewMode}, center)`;
              elmDialog.style.backgroundRepeat = "no-repeat";

              // add image to dialog__overlay__graph-right div
              const elmDialogImgDiv = document.querySelector(".dialog__overlay__graph-right");
              if (elmDialogImgDiv) {
                elmDialogImgDiv.style.backgroundImage = `${maskImage}url('${bgImage}')`;
                const imgTag = elmDialogImgDiv.querySelector("img");
                if (imgTag) {
                  imgTag.src = bgImage;
                }
              }
            }
          });
        }
      }
    });

    initBotInstance();
    toggleChatVisibility(true);
  };

  kariStartTemplate();
  /* Events */
  bindDialogEvents();
}
